import { styled } from 'mz-ui-kit'

export const Label = styled('div', {
  textAlign: 'center',
  marginTop: '4px'
});
